var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_setup.wallets),function(wallet){return _c(_setup.AmountDisplay,{key:wallet.currency,attrs:{"currency":wallet.currency,"value":wallet.wallet?.availableBalance,"label":wallet.label,"loading":!wallet.wallet}})}),(_vm.redirectTo)?_c('DashboardViewAllButton',{on:{"click":_setup.goToWallets}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }